export default "/_next/static/images/02/stairs@2x-029d23d315b82953878687d94e8c15d1.jpg";